import http from "@/http-common";

class UserListDataService {
  getDestinationList(): Promise<any> {
    return http.api.post("/getDestinationList/");
  }
  getUserInquiry(data: any): Promise<any> {
    return http.api.post("/getUserInquiry/", data);
  }
  getUserInformation(data: any): Promise<any> {
    return http.api.post("/getUserInformation/", data);
  }
  updateUserStatus(data: any): Promise<any> {
    return http.api.post("/updateUserStatus/", data);
  }
}
export default new UserListDataService();
